<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de atendimento diário">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/farmacia/relatorio-atendimento-diario/List'

export default {
    components: {
        List,
    },
}
</script>